import React, { useCallback } from 'react';
import { Input } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from './PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SettingsCheckRowProps {
  id: string;
  title: string;
  note?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** One checkbox with a title and a help line. */
const SettingsCheckRowComponent: React.FC<SettingsCheckRowProps> = ({ id, title, note, checked, onChange }) => {
  const change = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
    [onChange]
  );
  return (
    <div className={styles.row}>
      <Input id={id} type="checkbox" checked={checked} onChange={change} />
      <label className={styles.rowText} htmlFor={id}>
        <span className={styles.rowTitle}>{title}</span>
        {note === undefined ? null : <span className={styles.small}>{note}</span>}
      </label>
    </div>
  );
};

export const SettingsCheckRow = TypedMemo(SettingsCheckRowComponent);
